export default __webpack_public_path__ + "static/media/checked.f84dda55.svg";